// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jsk4","left":"styles_left__2mHEc"};